module.exports = __webpack_public_path__ + "img/3bhk-c1.28c8bedb.jpg";